module.exports = __webpack_public_path__ + "src/images/products/allAmerican/76_Slub Crewneck Pocket T-shirt.png";